import { useMemo } from 'react';

import { getEventPlayerIds } from '@/feature/entries-pickem/entries-utils';

export const useEventPlayerIds = (picks: { eventId: string; player: { id: string } }[] | null | undefined) =>
    useMemo(() => getEventPlayerIds(picks), [picks]);
